import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";
import { COMPANY } from "../lib/company";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-5 flex items-center justify-between">
          <BrandMark />
          <Link to="/" className="hop-link text-sm">← на главную</Link>
        </div>
      </header>

      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-8 py-16 md:py-24">
          <div className="label-mono">УСЛОВИЯ</div>
          <h1 className="mt-3 text-4xl md:text-5xl tracking-tight font-medium">
            Условия использования<br />сервиса
          </h1>
          <p className="mt-4 text-foreground/60 mono text-xs">Редакция от 30 апреля 2026 г.</p>

          <div className="prose mt-12 space-y-8 text-foreground/85 leading-relaxed">

            <Section num="01" title="Общие положения">
              <p>
                Настоящие Условия использования (далее — Условия) регулируют отношения между
                {" "}{COMPANY.legalName}, ИНН {COMPANY.inn}, ОГРН {COMPANY.ogrn},
                юридический адрес: {COMPANY.address} (далее — Оператор),
                и&nbsp;любым лицом, использующим онлайн-сервис диагностики стартапов,
                размещённый на&nbsp;домене {COMPANY.service.domain} (далее — Сервис, Пользователь).
              </p>
              <p>
                Использование Сервиса — заполнение анкеты, загрузка презентации, получение
                результата по&nbsp;ссылке — означает безоговорочное согласие Пользователя
                с&nbsp;настоящими Условиями. Если Пользователь не&nbsp;согласен с&nbsp;каким-либо
                пунктом — следует прекратить использование Сервиса.
              </p>
            </Section>

            <Section num="02" title="Предмет Сервиса">
              <p>
                Сервис — это автоматизированный диагностический инструмент, который на&nbsp;основе
                ответов Пользователя на&nbsp;26 или 50 вопросов и&nbsp;(опционально) загруженной
                Пользователем презентации рассчитывает три независимых индекса готовности
                стартапа: к&nbsp;инвесторскому интересу, к&nbsp;корпоративным пилотам, к&nbsp;поддержке
                институтов развития. Индексы выводятся в&nbsp;шкале 0–100 с&nbsp;качественными бэндами
                и&nbsp;набором рекомендаций на&nbsp;90&nbsp;дней.
              </p>
            </Section>

            <Section num="03" title="Методологическая оговорка">
              <p>
                Результат диагностики <strong>не&nbsp;является</strong> прогнозом получения
                инвестиций, гранта или корпоративного пилота, не&nbsp;является обязательством
                со&nbsp;стороны Оператора и&nbsp;его партнёров вступить с&nbsp;Пользователем
                в&nbsp;какие-либо отношения, не&nbsp;является инвестиционной рекомендацией,
                юридической, налоговой или финансовой консультацией.
              </p>
              <p>
                Индексы показывают, насколько параметры проекта Пользователя похожи
                на&nbsp;признаки, которые в&nbsp;исследовательской базе Оператора чаще связаны
                с&nbsp;соответствующим типом интереса. Это статистическое сходство,
                а&nbsp;не&nbsp;гарантия исхода.
              </p>
              <p>
                Пользователь принимает решения относительно своего проекта самостоятельно
                и&nbsp;на&nbsp;свой риск. Оператор не&nbsp;несёт ответственности за&nbsp;любые решения,
                принятые Пользователем на&nbsp;основании результатов Сервиса.
              </p>
            </Section>

            <Section num="04" title="Условия использования">
              <p>Пользователь обязуется:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>предоставлять достоверную информацию о&nbsp;своём проекте;</li>
                <li>не&nbsp;использовать Сервис для подачи заведомо ложных, тестовых
                    или&nbsp;спам-данных в&nbsp;промышленных объёмах;</li>
                <li>загружать только те&nbsp;файлы презентаций, на&nbsp;использование которых
                    у&nbsp;Пользователя есть законные права;</li>
                <li>не&nbsp;пытаться получить несанкционированный доступ к&nbsp;административной
                    части Сервиса, не&nbsp;нарушать его работу, не&nbsp;использовать средства
                    автоматизированной обработки (парсеры, боты) без&nbsp;письменного согласия
                    Оператора;</li>
                <li>не&nbsp;размещать в&nbsp;ответах и&nbsp;файлах материалы, нарушающие
                    законодательство Российской Федерации, права третьих лиц или содержащие
                    вредоносный код.</li>
              </ul>
            </Section>

            <Section num="05" title="Использование искусственного интеллекта">
              <p>
                Открытые текстовые ответы Пользователя и&nbsp;содержимое загруженной презентации
                могут передаваться сторонним языковым моделям. Языковая модель анализирует
                данные, извлекает структурированные признаки и&nbsp;участвует в&nbsp;расчёте
                итоговых индексов вместе с&nbsp;детерминированным модулем на&nbsp;стороне Сервиса.
              </p>
              <p>
                Передача данных языковой модели осуществляется только при наличии отдельного
                согласия Пользователя, выраженного на&nbsp;экране согласий перед заполнением
                анкеты. Подробности — в{" "}
                <Link to="/privacy" className="hop-link">Политике обработки персональных данных</Link>.
              </p>
            </Section>

            <Section num="06" title="Загрузка презентации">
              <p>
                Загрузка презентации (PDF или PPTX, до&nbsp;50&nbsp;МБ) — опциональная функция.
                Файл сохраняется в&nbsp;защищённом объектном хранилище Оператора, доступ к&nbsp;нему
                имеют только сотрудники аналитического подразделения Оператора и&nbsp;технические
                компоненты Сервиса. Срок хранения — {COMPANY.retentionMonths} месяцев,
                после&nbsp;чего&nbsp;файл удаляется.
              </p>
              <p>
                Загружая презентацию, Пользователь подтверждает, что обладает необходимыми
                правами на&nbsp;её содержание и&nbsp;на&nbsp;её передачу Оператору в&nbsp;объёме,
                необходимом для оказания услуг Сервиса.
              </p>
            </Section>

            <Section num="07" title="Интеллектуальная собственность">
              <p>
                Все материалы Сервиса — методология, формулировки вопросов, шкалы, тексты
                рекомендаций, дизайн интерфейса, программный код и&nbsp;иные результаты
                интеллектуальной деятельности — принадлежат Оператору и&nbsp;охраняются
                в&nbsp;соответствии с&nbsp;законодательством Российской Федерации.
              </p>
              <p>
                Пользователю предоставляется право использовать результат своей собственной
                диагностики (свой&nbsp;же отчёт) свободно, в&nbsp;том числе для&nbsp;размещения
                у&nbsp;себя, направления инвесторам и&nbsp;иных деловых целей. Копирование
                и&nbsp;распространение методологии, шкал, текста рекомендаций как&nbsp;продукта
                — возможно только с&nbsp;письменного согласия Оператора.
              </p>
              <p>
                Содержание загруженной Пользователем презентации остаётся интеллектуальной
                собственностью Пользователя.
              </p>
            </Section>

            <Section num="08" title="Доступность Сервиса">
              <p>
                Сервис предоставляется по&nbsp;модели &laquo;как есть&raquo;. Оператор стремится
                обеспечить непрерывную работу Сервиса, но&nbsp;не&nbsp;гарантирует его постоянную
                доступность и&nbsp;вправе временно приостанавливать работу для технического
                обслуживания, обновлений и&nbsp;по&nbsp;иным причинам.
              </p>
              <p>
                В&nbsp;случае технических сбоев со&nbsp;стороны языковых моделей или объектного
                хранилища расчёт индексов может выполняться с&nbsp;понижением достоверности
                (с&nbsp;соответствующей пометкой) или быть временно недоступным.
              </p>
            </Section>

            <Section num="09" title="Ограничение ответственности">
              <p>
                В&nbsp;максимальной степени, разрешённой применимым законодательством, Оператор
                не&nbsp;несёт ответственности перед Пользователем за&nbsp;любые косвенные убытки,
                упущенную выгоду, потерю репутации, отказ инвестора, отказ корпорации от&nbsp;пилота,
                отказ института развития от&nbsp;поддержки, а&nbsp;также за&nbsp;иные последствия
                использования или&nbsp;невозможности использования Сервиса.
              </p>
            </Section>

            <Section num="10" title="Удаление данных">
              <p>
                Пользователь вправе в&nbsp;любое время направить запрос на&nbsp;удаление своей
                анкеты, загруженной презентации и&nbsp;контактных данных по&nbsp;адресу{" "}
                <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
                Запрос рассматривается в&nbsp;течение&nbsp;10 рабочих дней. Подробнее
                в{" "}<Link to="/privacy" className="hop-link">Политике обработки персональных данных</Link>.
              </p>
            </Section>

            <Section num="11" title="Изменение Условий">
              <p>
                Оператор вправе вносить изменения в&nbsp;настоящие Условия. Актуальная редакция
                всегда публикуется по&nbsp;адресу https://{COMPANY.service.domain}/terms.
                Дата последней редакции указана в&nbsp;начале документа.
              </p>
              <p>
                Если Пользователь продолжает пользоваться Сервисом после публикации новой
                редакции — это считается принятием новых Условий.
              </p>
            </Section>

            <Section num="12" title="Применимое право и разрешение споров">
              <p>
                К&nbsp;настоящим Условиям применяется законодательство Российской Федерации.
                Все споры, возникающие в&nbsp;связи с&nbsp;использованием Сервиса, подлежат
                рассмотрению в&nbsp;суде по&nbsp;месту нахождения Оператора в&nbsp;г.&nbsp;Москве,
                с&nbsp;соблюдением обязательного претензионного порядка: претензии направляются
                на&nbsp;адрес <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
                и&nbsp;рассматриваются в&nbsp;течение 30 календарных дней.
              </p>
            </Section>

            <Section num="13" title="Контакты Оператора">
              <p>
                {COMPANY.legalName}<br />
                Адрес: {COMPANY.address}<br />
                ИНН {COMPANY.inn}, КПП {COMPANY.kpp}, ОГРН {COMPANY.ogrn}<br />
                Телефон: {COMPANY.phone}<br />
                E-mail: <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </p>
            </Section>

          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

function Section({ num, title, children }) {
  return (
    <section>
      <div className="label-mono mb-3">{num}</div>
      <h2 className="text-2xl font-medium tracking-tight">{title}</h2>
      <div className="mt-4 space-y-3">{children}</div>
    </section>
  );
}
